export default function(menuButton, rootElement) {
  if (!menuButton) {
    return;
  }

  const target = rootElement.querySelector(`#${menuButton.getAttribute('aria-controls')}`);

  if (!target) {
    return;
  }

  const expanded = menuButton.getAttribute('aria-expanded') === 'false';

  const selectMenuButtons = rootElement.querySelectorAll('[data-role="select-menu-button"]');
  const selectMenus = rootElement.querySelectorAll('[aria-role="select-menu"]');

  Array.from(selectMenuButtons).forEach(selectMenuButton => {
    selectMenuButton.setAttribute('aria-expanded', false);
  });

  Array.from(selectMenus).forEach(selectMenu => {
    selectMenu.setAttribute('aria-hidden', true);
  });

  menuButton.setAttribute('aria-expanded', Boolean(expanded));
  target.setAttribute('aria-hidden', !expanded);
  rootElement.style.overflow = (expanded ? 'visible' : null);

  const dims = target.getBoundingClientRect();
  const top = (window.innerHeight - dims.top);

  if ((target.scrollHeight - dims.height) > 0) {
    target.style.height = `${top - 12}px`;
    target.scrollTop = 0;
  }
}
